import { render, staticRenderFns } from "./Test3D.vue?vue&type=template&id=33f46442&scoped=true"
import script from "./Test3D.vue?vue&type=script&lang=js"
export * from "./Test3D.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f46442",
  null
  
)

export default component.exports